export const heroSlides = [
  {
    title: "CupidAura",
    eyebrow: "Aesthetic Couple Gifts",
    description:
      "Send adorable plushies, promise jewelry, and curated surprise combos to your favorite person.",
    image:
      "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?w=1600&auto=format&fit=crop&q=80",
  },
  {
    title: "Cuddles in a Box",
    eyebrow: "Cute Plushies & Toys",
    description:
      "Super soft, blushing, magnetic matching toys designed to bridge the distance.",
    image:
      "https://images.unsplash.com/photo-1559454403-b8fb88521f11?w=1600&auto=format&fit=crop&q=80",
  },
  {
    title: "Whispers of Love",
    eyebrow: "Premium Promise Jewelry",
    description:
      "Handcrafted sterling silver rings and magnetic attraction bracelets to hold hands forever.",
    image:
      "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=1600&auto=format&fit=crop&q=80",
  },
];

export const mockProducts = [];
const _deprecatedMockProducts = [
  {
    title: "Blush Cuddle Bear",
    price: 3200,
    discountPrice: 2200,
    discount: 31,
    category: "Cute Plushies",
    fabric: "Cotton Plush",
    occasion: "Birthday",
    color: "Blush Pink",
    images: [
      "/toys/IMG_4912.PNG",
    ],
    video: null,
    stock: 12,
    rating: 4.8,
    reviews: 132,
    isNew: false,
    isBestSeller: true,
    description:
      "A sweet blushing teddy bear holding a small velvet heart. Made from premium cotton-plush, it makes the perfect cuddle companion.",
  },
  {
    _id: "p3",
    title: "Twin Hearts Necklace — Silver",
    price: 6900,
    discountPrice: 4999,
    discount: 27,
    category: "Fine Jewelry",
    fabric: "925 Sterling Silver",
    occasion: "Anniversary",
    color: "Silver",
    images: [
      "/jewelley/IMG_3611.JPG.jpeg",
    ],
    video: null,
    stock: 35,
    rating: 5.0,
    reviews: 342,
    isNew: true,
    isBestSeller: false,
    description:
      "Elegant 925 sterling silver chain with double interlocking hearts. Symbolizes two hearts connected across any distance.",
  },
  {
    _id: "p4",
    title: "Matching Infinity Bracelets",
    price: 5500,
    discountPrice: 3999,
    discount: 27,
    category: "Fine Jewelry",
    fabric: "Stainless Steel",
    occasion: "Long Distance",
    color: "Black & White",
    images: [
      "/jewelley/IMG_3617.JPG.jpeg",
    ],
    video: null,
    stock: 45,
    rating: 4.9,
    reviews: 187,
    isNew: false,
    isBestSeller: false,
    description:
      "Matching adjustable rope bracelets featuring hand-polished infinity charms. Designed for daily wear to signify endless devotion.",
  },
  {
    _id: "p5",
    title: "Star Map — The Night We Met",
    price: 4999,
    discountPrice: 3999,
    discount: 20,
    category: "Personalized Gifts",
    fabric: "Wood & Paper",
    occasion: "Anniversary",
    color: "Navy Blue",
    images: [
      "/jewelley/IMG_3652.JPG.jpeg",
    ],
    video: null,
    stock: 20,
    rating: 4.9,
    reviews: 411,
    isNew: false,
    isBestSeller: true,
    description:
      "A custom printed constellation star chart aligned to the exact night and location you met. Stamped on high-quality paper with frame.",
  },
  {
    _id: "p6",
    title: "365 Reasons Love Letter Set",
    price: 2200,
    discountPrice: 1599,
    discount: 27,
    category: "Surprise Boxes",
    fabric: "Glass & Paper",
    occasion: "Valentine's Day",
    color: "Crimson",
    images: [
      "/jewelley/IMG_3653.JPG.jpeg",
    ],
    video: null,
    stock: 60,
    rating: 4.8,
    reviews: 96,
    isNew: false,
    isBestSeller: false,
    description:
      "A jar filled with 365 handwritten-style capsules containing sweet reasons why you love them. One surprise note to open for every single day.",
  },

  // ─── FINE JEWELRY (p7 - p12) ──────────────────────────────
  {
    _id: "p7",
    title: "Alaira Love Hamper — Premium",
    price: 9999,
    discountPrice: 7999,
    discount: 20,
    category: "Romantic Combos",
    fabric: "Luxury Box",
    occasion: "Anniversary",
    color: "Soft Pink",
    images: [
      "/flowers/IMG_4930.PNG",
    ],
    video: null,
    stock: 15,
    rating: 5.0,
    reviews: 274,
    isNew: true,
    isBestSeller: true,
    description:
      "A signature premium gift box containing a Cloud Bear, truffles, customized love notes, signature room scent, and a wax-sealed love letter.",
  },
  {
    _id: "p8",
    title: "His & Hers Sunrise Mugs",
    price: 2800,
    discountPrice: 2299,
    discount: 18,
    category: "Romantic Combos",
    fabric: "Ceramic",
    occasion: "Just Because",
    color: "Pink & Blue",
    images: [
      "/flowers/IMG_4948.PNG",
    ],
    video: null,
    stock: 30,
    rating: 4.7,
    reviews: 88,
    isNew: false,
    isBestSeller: true,
    description:
      "Two hugging ceramic coffee mugs in soft pastel pink and sky blue glazes. A daily morning reminder of love, even if miles apart.",
  },
  {
    _id: "p9",
    title: "Sun & Moon Magnetic Pendants",
    price: 2500,
    discountPrice: 1999,
    discount: 20,
    category: "Fine Jewelry",
    fabric: "Sterling Silver",
    occasion: "Dating Anniversary",
    color: "Gold & Silver",
    images: [
      "/jewelley/IMG_3617.JPG.jpeg",
    ],
    video: null,
    stock: 22,
    rating: 4.7,
    reviews: 95,
    isNew: true,
    isBestSeller: false,
    description:
      "Cute celestial sun and moon necklaces. When held close, they magnetically attract and connect. Beautifully polished design.",
  },
  {
    _id: "p10",
    title: "Custom Engraved Plate Bracelet",
    price: 2200,
    discountPrice: 1799,
    discount: 18,
    category: "Fine Jewelry",
    fabric: "Titanium Steel",
    occasion: "Birthday",
    color: "Rose Gold",
    images: [
      "/jewelley/IMG_3612.JPG.jpeg",
    ],
    video: null,
    stock: 18,
    rating: 4.6,
    reviews: 73,
    isNew: false,
    isBestSeller: false,
    description:
      "A delicate custom bracelet in rose gold finish. Features a sleek metallic bar that can be custom engraved with names or special dates.",
  },
  {
    _id: "p11",
    title: "Crystal Heart Promise Ring",
    price: 1900,
    discountPrice: 1599,
    discount: 16,
    category: "Fine Jewelry",
    fabric: "Rose Gold Plated",
    occasion: "Anniversary",
    color: "Rose Gold",
    images: [
      "/jewelley/IMG_3652.JPG.jpeg",
    ],
    video: null,
    stock: 24,
    rating: 4.9,
    reviews: 62,
    isNew: true,
    isBestSeller: false,
    description:
      "A gorgeous rose-gold plated ring with a sparkling heart-shaped crystal center. Speaks volumes of love in a minimal look.",
  },
  {
    _id: "p12",
    title: "Distance Crown Bead Bracelets",
    price: 1200,
    discountPrice: 899,
    discount: 25,
    category: "Fine Jewelry",
    fabric: "Natural Stone Beads",
    occasion: "Long Distance",
    color: "Black & White",
    images: [
      "/jewelley/IMG_3654.JPG.jpeg",
    ],
    video: null,
    stock: 40,
    rating: 4.5,
    reviews: 135,
    isNew: false,
    isBestSeller: false,
    description:
      "A set of matching crown-topped bead bracelets. White Howlite for her, Black Matte Agate for him. Keep each other close even when apart.",
  },

  // ─── ROMANTIC COMBOS (p13 - p18) ──────────────────────────
  {
    _id: "p13",
    title: "Sweethearts Chocolate & Rose Hamper",
    price: 4999,
    discountPrice: 3999,
    discount: 20,
    category: "Romantic Combos",
    fabric: "Premium Scented Kit",
    occasion: "Valentine's Day",
    color: "Romantic Red",
    images: [
      "/flowers/IMG_4930.PNG",
      "/flowers/IMG_4948.PNG",
    ],
    video: null,
    stock: 15,
    rating: 4.9,
    reviews: 242,
    isNew: true,
    isBestSeller: true,
    description:
      "A beautiful pastel pink gift hamper containing a bouquet of fresh red roses, premium artisanal chocolates, a custom polaroid frame, and a greeting card.",
  },
  {
    _id: "p14",
    title: "Morning Cuddle Ceramic Mugs",
    price: 1800,
    discountPrice: 1499,
    discount: 17,
    category: "Romantic Combos",
    fabric: "Ceramic",
    occasion: "Anniversary",
    color: "Pink & Blue",
    images: [
      "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 25,
    rating: 4.8,
    reviews: 83,
    isNew: false,
    isBestSeller: false,
    description:
      "A set of premium ceramic coffee mugs with cute heart-shaped handles that fit together perfectly. Handcrafted pastel pink and soft blue glazes.",
  },
  {
    _id: "p15",
    title: "Cozy Couple Bedtime Set",
    price: 2900,
    discountPrice: 2399,
    discount: 17,
    category: "Romantic Combos",
    fabric: "Satin & Cotton",
    occasion: "Birthday",
    color: "Pastel Lavender",
    images: [
      "https://images.unsplash.com/photo-1512909006721-3d6018887383?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 18,
    rating: 4.7,
    reviews: 64,
    isNew: true,
    isBestSeller: false,
    description:
      "Create cozy memories! Includes matching soft satin sleep masks, a calming lavender scented soy candle, and cute plush fuzzy socks.",
  },
  {
    _id: "p16",
    title: "Our Story Scrapbook Photo Album",
    price: 1999,
    discountPrice: 1599,
    discount: 20,
    category: "Romantic Combos",
    fabric: "Recycled Paper",
    occasion: "Anniversary",
    color: "Kraft Brown",
    images: [
      "https://images.unsplash.com/photo-1512909006721-3d6018887383?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 30,
    rating: 4.9,
    reviews: 156,
    isNew: false,
    isBestSeller: true,
    description:
      "A DIY memory scrapbook with 40 pages, cute stickers, metallic markers, and photo corners. The best way to catalog your relationship milestones.",
  },
  {
    _id: "p17",
    title: "Eternal Preserved Rose & Silver Ring Box",
    price: 5500,
    discountPrice: 4800,
    discount: 12,
    category: "Romantic Combos",
    fabric: "Real Preserved Flower",
    occasion: "Valentine's Day",
    color: "Soft Crimson",
    images: [
      "https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 8,
    rating: 5.0,
    reviews: 53,
    isNew: true,
    isBestSeller: true,
    description:
      "A real, hand-preserved rose that lasts for up to 3 years. Hidden underneath is a jewelry drawer containing a beautiful silver adjustable ring.",
  },
  {
    _id: "p18",
    title: "Couple's Mug & Chocolate Box",
    price: 2400,
    discountPrice: 1990,
    discount: 17,
    category: "Romantic Combos",
    fabric: "Multi",
    occasion: "Just Because",
    color: "Assorted",
    images: [
      "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 14,
    rating: 4.6,
    reviews: 42,
    isNew: false,
    isBestSeller: false,
    description:
      "A wonderful gift tray containing a customized couple mug and a hand-painted box of assorted dark chocolate truffles.",
  },

  // ─── MATCHING PIECES (p19 - p24) ──────────────────────────
  {
    _id: "p19",
    title: "Custom Embroidery Couple Hoodies",
    price: 4999,
    discountPrice: 3999,
    discount: 20,
    category: "Matching Pieces",
    fabric: "Organic Fleece Cotton",
    occasion: "Anniversary",
    color: "Soft Blue & Soft Pink",
    images: [
      "https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=600&auto=format&fit=crop&q=80",
      "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 10,
    rating: 4.9,
    reviews: 98,
    isNew: true,
    isBestSeller: true,
    description:
      "Two premium organic cotton hoodies. Features custom embroidered initials and a small heart logo on the sleeves.",
  },
  {
    _id: "p20",
    title: "King & Queen Matching Caps",
    price: 1800,
    discountPrice: 1299,
    discount: 27,
    category: "Matching Pieces",
    fabric: "Washed Canvas Cotton",
    occasion: "Just Because",
    color: "Black & Pink",
    images: [
      "https://images.unsplash.com/photo-1618677603286-0ec5629f412c?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 35,
    rating: 4.4,
    reviews: 79,
    isNew: false,
    isBestSeller: false,
    description:
      "Classy washed canvas baseball caps. Features minimal 'King' embroidery on one cap, and 'Queen' on the other in a matching cursive font.",
  },
  {
    _id: "p21",
    title: "Magnetic Attraction Rope Bracelets",
    price: 999,
    discountPrice: 699,
    discount: 30,
    category: "Matching Pieces",
    fabric: "Braided Nylon Rope",
    occasion: "Long Distance",
    color: "Ocean Blue & Soft Pink",
    images: [
      "https://images.unsplash.com/photo-1598518141892-06ba05f87be7?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 50,
    rating: 4.8,
    reviews: 145,
    isNew: true,
    isBestSeller: true,
    description:
      "Simple, adjustable braided rope bracelets with a magnetic half-sphere lock. When the couple holds hands, the spheres connect into one.",
  },
  {
    _id: "p22",
    title: "Puzzle Heart Keychains Set",
    price: 700,
    discountPrice: 499,
    discount: 28,
    category: "Matching Pieces",
    fabric: "Polished Stainless Steel",
    occasion: "Just Because",
    color: "Silver",
    images: [
      "https://images.unsplash.com/photo-1598518141892-06ba05f87be7?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 80,
    rating: 4.6,
    reviews: 83,
    isNew: false,
    isBestSeller: false,
    description:
      "Two steel interlocking puzzle keychains that assemble into a complete heart shape. Simple, cute, and perfect for carrying everyday.",
  },
  {
    _id: "p23",
    title: "Custom Polaroid Canvas Print Voucher",
    price: 1500,
    discountPrice: 1199,
    discount: 20,
    category: "Matching Pieces",
    fabric: "Canvas & Wood",
    occasion: "Anniversary",
    color: "Natural Wood",
    images: [
      "https://images.unsplash.com/photo-1543791187-df796fc11833?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 100,
    rating: 4.9,
    reviews: 120,
    isNew: false,
    isBestSeller: true,
    description:
      "Get your favorite photo printed as a classic polaroid block canvas with a wooden magnetic desk stand. Gift voucher style.",
  },
  {
    _id: "p24",
    title: "Cute Matching Couple Socks Set",
    price: 900,
    discountPrice: 650,
    discount: 27,
    category: "Matching Pieces",
    fabric: "Organic Cotton",
    occasion: "Just Because",
    color: "White & Cream",
    images: [
      "https://images.unsplash.com/photo-1512909006721-3d6018887383?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 45,
    rating: 4.5,
    reviews: 38,
    isNew: false,
    isBestSeller: false,
    description:
      "Cute socks with magnetic hands on the sides that automatically hold hands when the feet are close. Bring sweet smiles!",
  },

  // ─── SWEET SURPRISES (p25 - p30) ──────────────────────────
  {
    _id: "p25",
    title: "100 Love Message Capsules in a Jar",
    price: 1500,
    discountPrice: 999,
    discount: 33,
    category: "Sweet Surprises",
    fabric: "Glass & Capsules",
    occasion: "Just Because",
    color: "Pastel Mix",
    images: [
      "https://images.unsplash.com/photo-1608454367599-c1139e64f7df?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 30,
    rating: 4.9,
    reviews: 127,
    isNew: true,
    isBestSeller: true,
    description:
      "A cute glass jar containing 100 miniature plastic capsules. Inside each capsule is a blank tiny slip of paper with a metal ring, ready for cute personal notes.",
  },
  {
    _id: "p26",
    title: "Lavender Love Scented Soy Candle",
    price: 1200,
    discountPrice: 899,
    discount: 25,
    category: "Sweet Surprises",
    fabric: "Natural Soy Wax",
    occasion: "Anniversary",
    color: "Soft Purple",
    images: [
      "https://images.unsplash.com/photo-1603006905003-be475563bc59?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 40,
    rating: 4.8,
    reviews: 84,
    isNew: false,
    isBestSeller: false,
    description:
      "Hand-poured 100% soy wax scented candle in a pink frosted glass jar. Emits a soothing French Lavender aroma, burning up to 35 hours.",
  },
  {
    _id: "p27",
    title: "LED Custom Polaroid Photo Frame",
    price: 2200,
    discountPrice: 1799,
    discount: 18,
    category: "Sweet Surprises",
    fabric: "Acrylic & Wood",
    occasion: "Anniversary",
    color: "Warm White Glow",
    images: [
      "https://images.unsplash.com/photo-1513151233558-d860c5398176?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 15,
    rating: 4.8,
    reviews: 69,
    isNew: true,
    isBestSeller: true,
    description:
      "A custom acrylic plaque styled like a Polaroid photo. Sits on a premium LED wooden base that softly illuminates your photo under warm light.",
  },
  {
    _id: "p28",
    title: "52 Weeks Love Challenge Deck",
    price: 999,
    discountPrice: 799,
    discount: 20,
    category: "Sweet Surprises",
    fabric: "Premium Cardstock",
    occasion: "Valentine's Day",
    color: "Soft Red & Pink",
    images: [
      "https://images.unsplash.com/photo-1512909006721-3d6018887383?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 50,
    rating: 4.7,
    reviews: 58,
    isNew: false,
    isBestSeller: false,
    description:
      "A deck of cards with 52 fun, romantic, and thoughtful date challenges for couples to try out over the year. Build a deeper bond.",
  },
  {
    _id: "p29",
    title: "Handmade Surprise Explosion Box",
    price: 2500,
    discountPrice: 1999,
    discount: 20,
    category: "Sweet Surprises",
    fabric: "Premium Art Card",
    occasion: "Birthday",
    color: "Pink & Black",
    images: [
      "https://images.unsplash.com/photo-1512909006721-3d6018887383?w=600&auto=format&fit=crop&q=80",
    ],
    video: null,
    stock: 12,
    rating: 4.9,
    reviews: 140,
    isNew: false,
    isBestSeller: true,
    description:
      "When closed, it looks like a gift box. Once opened, all sides fall back to reveal layers of photos, card pockets, and a tiny gift box in the center.",
  },
  // ─── CHOCOLATES & SWEETS (p31 - p45) ─────────────────────
  {
    _id: "p31",
    title: "KitKat Classic Crisp Wafer Chocolate",
    price: 199,
    discountPrice: 149,
    discount: 25,
    category: "Chocolates",
    fabric: "Crisp Wafer & Milk Chocolate",
    occasion: "Just Because",
    color: "Red",
    images: ["/sweets/IMG_4049.WEBP"],
    video: null,
    stock: 50,
    rating: 4.8,
    reviews: 110,
    isNew: false,
    isBestSeller: true,
    description: "Classic crisp wafer fingers enveloped in smooth milk chocolate. Have a break, have a KitKat."
  },
  {
    _id: "p32",
    title: "KitKat King Size Crunchy Bar Pack",
    price: 299,
    discountPrice: 249,
    discount: 17,
    category: "Chocolates",
    fabric: "Rich Milk Chocolate",
    occasion: "Birthday",
    color: "Red",
    images: ["/sweets/IMG_4050.WEBP"],
    video: null,
    stock: 40,
    rating: 4.9,
    reviews: 95,
    isNew: true,
    isBestSeller: false,
    description: "King size crunch pack for ultimate chocolate lovers. Crispy wafer layers with extra thick cocoa coating."
  },
  {
    _id: "p33",
    title: "KitKat Minis Shareable Pouch",
    price: 499,
    discountPrice: 399,
    discount: 20,
    category: "Chocolates",
    fabric: "Bite-Sized Chocolates",
    occasion: "Party",
    color: "Red & White",
    images: ["/sweets/IMG_4051.WEBP"],
    video: null,
    stock: 35,
    rating: 4.7,
    reviews: 140,
    isNew: false,
    isBestSeller: true,
    description: "A fun shareable pouch filled with individually wrapped mini KitKat bites. Perfect for movie nights & couple dates."
  },
  {
    _id: "p34",
    title: "KitKat Chunky Finger Bar",
    price: 149,
    discountPrice: 99,
    discount: 33,
    category: "Chocolates",
    fabric: "Thick Chocolate Wafer",
    occasion: "Casual",
    color: "Red",
    images: ["/sweets/IMG_4052.WEBP"],
    video: null,
    stock: 60,
    rating: 4.6,
    reviews: 78,
    isNew: false,
    isBestSeller: false,
    description: "Single thick chunky bar with extra wafer crunch and creamy chocolate wrap."
  },
  {
    _id: "p35",
    title: "KitKat Multi-Pack Festive Edition",
    price: 599,
    discountPrice: 449,
    discount: 25,
    category: "Chocolates",
    fabric: "Assorted Milk Chocolates",
    occasion: "Anniversary",
    color: "Red",
    images: ["/sweets/IMG_4053.WEBP"],
    video: null,
    stock: 30,
    rating: 4.9,
    reviews: 180,
    isNew: true,
    isBestSeller: true,
    description: "Festive gift pack filled with multiple full-size KitKat chocolate bars."
  },
  {
    _id: "p36",
    title: "Cadbury Dairy Milk Silk Hazelnut Bliss",
    price: 350,
    discountPrice: 280,
    discount: 20,
    category: "Chocolates",
    fabric: "Silk Chocolate & Whole Hazelnuts",
    occasion: "Anniversary",
    color: "Purple & Gold",
    images: ["/sweets/IMG_4054.JPG.jpeg"],
    video: null,
    stock: 25,
    rating: 5.0,
    reviews: 215,
    isNew: false,
    isBestSeller: true,
    description: "Rich, velvety Cadbury Dairy Milk Silk loaded with crunchy whole roasted hazelnuts."
  },
  {
    _id: "p37",
    title: "KitKat Luxury Gift Box Collection",
    price: 899,
    discountPrice: 699,
    discount: 22,
    category: "Chocolates",
    fabric: "Premium Gift Box",
    occasion: "Valentine's Day",
    color: "Deep Crimson",
    images: ["/sweets/IMG_4055.JPG.jpeg"],
    video: null,
    stock: 20,
    rating: 4.9,
    reviews: 165,
    isNew: true,
    isBestSeller: true,
    description: "A gorgeous luxury gift box presentation of classic & specialty chocolate bars."
  },
  {
    _id: "p38",
    title: "Cadbury Dairy Milk Silk Roasted Almond",
    price: 350,
    discountPrice: 299,
    discount: 15,
    category: "Chocolates",
    fabric: "Creamy Cocoa & Almonds",
    occasion: "Birthday",
    color: "Purple",
    images: ["/sweets/IMG_4056.JPG.jpeg"],
    video: null,
    stock: 30,
    rating: 4.8,
    reviews: 142,
    isNew: false,
    isBestSeller: false,
    description: "Smooth melting Cadbury Silk studded with slow-roasted Californian almonds."
  },
  {
    _id: "p39",
    title: "Cadbury Silk Heart Blush Couple Edition",
    price: 499,
    discountPrice: 399,
    discount: 20,
    category: "Chocolates",
    fabric: "Heart Molded Silk Chocolate",
    occasion: "Valentine's Day",
    color: "Romantic Pink & Red",
    images: ["/sweets/IMG_4057.JPG.jpeg"],
    video: null,
    stock: 45,
    rating: 5.0,
    reviews: 320,
    isNew: true,
    isBestSeller: true,
    description: "Romantic couple special heart-pop Silk chocolate bar. The sweetest expression of affection."
  },
  {
    _id: "p40",
    title: "Cadbury Silk Oreo Crunch Chocolate",
    price: 320,
    discountPrice: 260,
    discount: 19,
    category: "Chocolates",
    fabric: "Oreo Cookie & Silk Chocolate",
    occasion: "Just Because",
    color: "Blue & Purple",
    images: ["/sweets/IMG_4058.JPG.jpeg"],
    video: null,
    stock: 40,
    rating: 4.8,
    reviews: 190,
    isNew: false,
    isBestSeller: true,
    description: "Crispy dark Oreo cookie crunch enveloped in silky melt-in-mouth Cadbury chocolate."
  },
  {
    _id: "p41",
    title: "Snickers Peanut Caramel Chocolate Bar Pack",
    price: 250,
    discountPrice: 199,
    discount: 20,
    category: "Chocolates",
    fabric: "Roasted Peanuts, Caramel & Nougat",
    occasion: "Casual",
    color: "Brown",
    images: ["/sweets/IMG_4059.JPG.jpeg"],
    video: null,
    stock: 50,
    rating: 4.7,
    reviews: 125,
    isNew: false,
    isBestSeller: false,
    description: "Packed with roasted peanuts, gooey caramel, and soft nougat coated in milk chocolate."
  },
  {
    _id: "p42",
    title: "Snickers Almond Crunch Energy Chocolate",
    price: 280,
    discountPrice: 220,
    discount: 21,
    category: "Chocolates",
    fabric: "Almonds, Caramel & Milk Cocoa",
    occasion: "Casual",
    color: "Golden Brown",
    images: ["/sweets/IMG_4060.JPG.jpeg"],
    video: null,
    stock: 35,
    rating: 4.6,
    reviews: 88,
    isNew: true,
    isBestSeller: false,
    description: "Satisfy your hunger with real crunchy almonds, rich caramel, and thick milk chocolate."
  },
  {
    _id: "p43",
    title: "Sunfeast Dark Fantasy Choco Fills Premium Box",
    price: 399,
    discountPrice: 320,
    discount: 20,
    category: "Chocolates",
    fabric: "Molten Choco Core & Dark Crust",
    occasion: "Tea Time & Date",
    color: "Dark Cocoa",
    images: ["/sweets/IMG_4061.JPG.jpeg"],
    video: null,
    stock: 40,
    rating: 4.9,
    reviews: 210,
    isNew: false,
    isBestSeller: true,
    description: "Crispy dark chocolate cookie exterior with a rich, warm molten chocolate center."
  },
  {
    _id: "p44",
    title: "Ferrero Rocher & Dark Chocolate Romance Box",
    price: 1299,
    discountPrice: 999,
    discount: 23,
    category: "Chocolates",
    fabric: "Hazelnut Praline & Dark Cocoa",
    occasion: "Anniversary",
    color: "Luxury Gold",
    images: ["/sweets/IMG_4062.JPG.jpeg"],
    video: null,
    stock: 15,
    rating: 5.0,
    reviews: 290,
    isNew: true,
    isBestSeller: true,
    description: "Exquisite golden-wrapped hazelnut pralines paired with rich dark cocoa chocolate truffles."
  },
  {
    _id: "p45",
    title: "Artisanal Handcrafted Silk & Truffles Combo",
    price: 1499,
    discountPrice: 1199,
    discount: 20,
    category: "Chocolates",
    fabric: "Handcrafted Cocoa Truffles",
    occasion: "Wedding & Anniversary",
    color: "Pastel Velvet",
    images: ["/sweets/IMG_4063.JPG.jpeg"],
    video: null,
    stock: 12,
    rating: 5.0,
    reviews: 175,
    isNew: true,
    isBestSeller: true,
    description: "Handcrafted gourmet chocolate truffles presented in an elegant velvet gift tray."
  },
  // ─── HEALTHY SWEETS & MAKHANA (p26 - p32) ──────────────────
  {
    _id: "p26",
    title: "Royal Makhana Gourmet Gift Box — Lavender & Gold",
    price: 1999,
    discountPrice: 1499,
    discount: 25,
    category: "Healthy Sweets",
    fabric: "Hand-harvested Makhana",
    occasion: "Festive & Celebrations",
    color: "Royal White & Purple",
    images: [
      "/kind of sweets but not choclate/image13.jpeg",
      "/kind of sweets but not choclate/image14.jpeg",
      "/kind of sweets but not choclate/image15.jpeg",
      "/kind of sweets but not choclate/image29.jpeg"
    ],
    video: null,
    stock: 20,
    rating: 4.9,
    reviews: 128,
    isNew: true,
    isBestSeller: true,
    description: "Hand-harvested lotus seeds (Makhana) slow-roasted in pure ghee and dusted with Himalayan pink salt & saffron. Beautifully encased in a regal white & purple presentation gift box."
  },
  {
    _id: "p27",
    title: "Artisanal Flavored Makhana Trio — Peri Peri, Pudina & Salted",
    price: 1299,
    discountPrice: 999,
    discount: 23,
    category: "Healthy Sweets",
    fabric: "Roasted Lotus Seeds",
    occasion: "Tea-Time & Gifting",
    color: "Amber & Obsidian",
    images: [
      "/kind of sweets but not choclate/image0.jpeg",
      "/kind of sweets but not choclate/image1.jpeg",
      "/kind of sweets but not choclate/image2.jpeg",
      "/kind of sweets but not choclate/image5.jpeg",
      "/kind of sweets but not choclate/image7.jpeg"
    ],
    video: null,
    stock: 35,
    rating: 4.8,
    reviews: 95,
    isNew: true,
    isBestSeller: true,
    description: "A luxury trio of gourmet roasted fox nut pouches featuring Spicy Peri Peri, Fresh Pudina Mint, and Himalayan Salt. 100% healthy, guilt-free crispy snacking."
  },
  {
    _id: "p28",
    title: "Jaggery Caramelized Gur Makhana & Dry Fruit Bites",
    price: 1599,
    discountPrice: 1199,
    discount: 25,
    category: "Healthy Sweets",
    fabric: "Organic Sugarcane Jaggery",
    occasion: "Festivals & Weddings",
    color: "Golden Jaggery",
    images: [
      "/kind of sweets but not choclate/image35.jpeg",
      "/kind of sweets but not choclate/image36.jpeg",
      "/kind of sweets but not choclate/image40.jpeg",
      "/kind of sweets but not choclate/image21.jpeg"
    ],
    video: null,
    stock: 18,
    rating: 4.9,
    reviews: 142,
    isNew: true,
    isBestSeller: false,
    description: "Crispy lotus seeds and roasted almonds glazed in pure organic sugarcane jaggery (Gur) and green cardamom. A rich, healthy traditional Indian delicacy."
  },
  {
    _id: "p29",
    title: "Crispy Lotus Seed & Berry Trail Nibbles (Pack of 4)",
    price: 1199,
    discountPrice: 899,
    discount: 25,
    category: "Healthy Sweets",
    fabric: "Berry & Seed Crunch",
    occasion: "Everyday Wellness",
    color: "Emerald Green",
    images: [
      "/kind of sweets but not choclate/image23.jpeg",
      "/kind of sweets but not choclate/image24.jpeg",
      "/kind of sweets but not choclate/image25.jpeg",
      "/kind of sweets but not choclate/image28.jpeg"
    ],
    video: null,
    stock: 40,
    rating: 4.7,
    reviews: 86,
    isNew: false,
    isBestSeller: true,
    description: "Vibrant fusion of popped lotus seeds, dried wild cranberries, blueberries, and pumpkin seeds. Fiber-rich, sweet & tangy healthy crunch packs."
  },
  {
    _id: "p30",
    title: "Gourmet Cookie Craft Display Tin Trio — Butter, Choco & Coconut",
    price: 1799,
    discountPrice: 1299,
    discount: 28,
    category: "Healthy Sweets",
    fabric: "Oat & Butter Crunch",
    occasion: "Birthdays & Corporate Gifting",
    color: "Pastel Cream & Blue",
    images: [
      "/kind of sweets but not choclate/image45.jpeg",
      "/kind of sweets but not choclate/image47.jpeg",
      "/kind of sweets but not choclate/image49.jpeg",
      "/kind of sweets but not choclate/image12.jpeg"
    ],
    video: null,
    stock: 25,
    rating: 5.0,
    reviews: 110,
    isNew: true,
    isBestSeller: false,
    description: "Melt-in-your-mouth artisanal cookie tins baked with organic oats, cultured butter, Belgian dark chocolate chips, and toasted coconut flakes."
  },
  {
    _id: "p31",
    title: "Signature Matte Black Truffle Roasted Makhana Canister",
    price: 2199,
    discountPrice: 1699,
    discount: 23,
    category: "Healthy Sweets",
    fabric: "Truffle Roasted Lotus Seeds",
    occasion: "VIP Gifting",
    color: "Matte Black & Gold",
    images: [
      "/kind of sweets but not choclate/image41.jpeg",
      "/kind of sweets but not choclate/image43.jpeg",
      "/kind of sweets but not choclate/image17.jpeg",
      "/kind of sweets but not choclate/image19.jpeg"
    ],
    video: null,
    stock: 15,
    rating: 4.9,
    reviews: 64,
    isNew: true,
    isBestSeller: true,
    description: "Ultra-luxury black truffle infused roasted makhana presented in an airtight matte black metal canister. Designed for discerning gourmet lovers."
  },
  {
    _id: "p32",
    title: "Heritage Wooden Keepsake Makhana Gift Hamper",
    price: 3299,
    discountPrice: 2499,
    discount: 24,
    category: "Healthy Sweets",
    fabric: "Teakwood Box & Gourmet Sweets",
    occasion: "Anniversary & Luxury Wedding",
    color: "Teak & Warm Gold",
    images: [
      "/kind of sweets but not choclate/image50.jpeg",
      "/kind of sweets but not choclate/image20.jpeg",
      "/kind of sweets but not choclate/image22.jpeg",
      "/kind of sweets but not choclate/image11.jpeg"
    ],
    video: null,
    stock: 10,
    rating: 5.0,
    reviews: 215,
    isNew: false,
    isBestSeller: true,
    description: "Handcrafted teakwood keepsake chest containing 4 gourmet makhana pouches, roasted dry fruit laddoos, and a customized gold foil greeting note."
  }
];

export const mockCategories = [
  {
    name: "Toys",
    slug: "toys",
    image: "https://images.unsplash.com/photo-1559454403-b8fb88521f11?w=400",
    count: 24,
    tint: "#F4F0FF"
  },
  {
    name: "Jewelry",
    slug: "jewelry",
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400",
    count: 32,
    tint: "#FFF4F7"
  },
  {
    name: "Flowers",
    slug: "flowers",
    image: "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?w=400",
    count: 18,
    tint: "#EAF5FF"
  },
  {
    name: "Chocolates",
    slug: "sweets",
    image: "/sweets/IMG_4057.JPG.jpeg",
    count: 15,
    tint: "#FFF0F3"
  },
  {
    name: "Healthy Sweets",
    slug: "healthy-sweets",
    image: "/kind of sweets but not choclate/image13.jpeg",
    count: 29,
    tint: "#FDF4E3"
  }
];

export const mockReviews = [
  {
    _id: "r1",
    productId: "p1",
    name: "Aman Sen",
    email: "aman@example.com",
    rating: 5,
    title: "Too adorable!",
    comment:
      "My girlfriend absolutely loved it. The magnetic touch holds them together. Very cute packaging too.",
    date: "2026-06-12T10:30:00.000Z",
    verified: true,
  },
  {
    _id: "r2",
    productId: "p7",
    name: "Priya Das",
    rating: 5,
    title: "Beautiful promise rings",
    comment:
      "They look very premium and adjustable band is super helpful. Sterling silver hasn't tarnished.",
    date: "2026-06-08T14:10:00.000Z",
    verified: true,
  },
  {
    _id: "r3",
    productId: "p13",
    name: "Rishi Verma",
    email: "rishi@example.com",
    rating: 5,
    title: "Awesome surprise combo",
    comment:
      "Everything was arranged beautifully in the pastel box. Roses were fresh and chocolates were delicious.",
    date: "2026-06-15T09:45:00.000Z",
    verified: true,
  },
];

export const mockCoupons = [
  {
    _id: "c1",
    code: "WELCOME10",
    type: "percentage",
    discount: 10,
    maxUses: 100,
    usedCount: 23,
    expiryDate: "2027-12-31",
    isActive: true,
    minimumOrder: 500,
    applicableProducts: [],
    oneUsePerUser: true,
    usedBy: [],
  },
  {
    _id: "c2",
    code: "LOVE500",
    type: "fixed",
    discount: 500,
    maxUses: 50,
    usedCount: 12,
    expiryDate: "2027-10-31",
    isActive: true,
    minimumOrder: 2000,
    applicableProducts: [],
    oneUsePerUser: false,
    usedBy: [],
  },
];

export const mockOrders = [
  {
    _id: "o1",
    orderId: "VA10001",
    userEmail: "aman@example.com",
    customer: "Aman Sen",
    phone: "9876543210",
    products: [
      {
        productId: "p1",
        title: "Magnetic Hugging Panda Plushies",
        image:
          "https://images.unsplash.com/photo-1596495572065-1d48c1073d89?w=600",
        price: 1499,
        quantity: 1,
      },
    ],
    shippingAddress: {
      fullName: "Aman Sen",
      phone: "9876543210",
      address: "Pastel Gardens 4B",
      city: "Mumbai",
      state: "Maharashtra",
      pincode: "400050",
    },
    subtotal: 1499,
    couponCode: "WELCOME10",
    couponDiscount: 150,
    total: 1349,
    paymentMethod: "Razorpay",
    paymentStatus: "Paid",
    deliveryStatus: "Delivered",
    date: "2026-06-10T11:20:00.000Z",
  },
];

export const mockCustomers = [
  {
    _id: "u1",
    name: "Aman Sen",
    email: "aman@example.com",
    phone: "9876543210",
    totalOrders: 1,
    totalSpending: 1349,
    lastOrder: "2026-06-10T11:20:00.000Z",
  },
];

export const mockTestimonials = [
  {
    name: "Aman Sen",
    city: "Mumbai",
    rating: 5,
    comment:
      "The panda plushies look absolutely adorable. It made my girlfriend smile so bright. Beautifully packed with love.",
    avatar: "AS",
  },
  {
    name: "Meera Patel",
    city: "Ahmedabad",
    rating: 5,
    comment:
      "Ordered the promise rings. High quality silver and very aesthetic presentation. Perfect for an anniversary.",
    avatar: "MP",
  },
  {
    name: "Sunita Desai",
    city: "Pune",
    rating: 5,
    comment:
      "Loved the surprise rose box combo. Very fast delivery and excellent customer support.",
    avatar: "SD",
  },
];

export const videoStories = [
  {
    title: "Plushy Cuddles",
    caption: "Magnetic panda plushies locking cheeks",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
  {
    title: "Silver Glow",
    caption: "Shine test of sterling silver promise rings",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
  {
    title: "Love Box Unboxing",
    caption: "Premium ribbon-tied hamper unboxing flow",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
];

export const mockAdminStats = {
  totalOrders: 342,
  todayOrders: 12,
  pendingOrders: 14,
  deliveredOrders: 310,
  totalRevenue: 840500,
  totalProducts: 30,
  totalCustomers: 224,
  activeCoupons: 2,
  monthlyRevenue: [
    { month: "Jan", revenue: 45000, orders: 15 },
    { month: "Feb", revenue: 82000, orders: 28 },
    { month: "Mar", revenue: 94000, orders: 32 },
    { month: "Apr", revenue: 110000, orders: 40 },
    { month: "May", revenue: 145000, orders: 52 },
    { month: "Jun", revenue: 180000, orders: 65 },
  ],
  orderStatus: [
    { status: "Delivered", count: 310 },
    { status: "Shipped", count: 18 },
    { status: "Pending", count: 14 },
    { status: "Cancelled", count: 8 },
  ],
};
